import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useProductFeatures} from '../hooks/useProductFeatures.ts';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = useProductFeatures();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};
